export default "__VITE_ASSET__M9A59xmP__"